import { useCallback, useEffect, useState } from "react"
import { useNavigate } from "react-router-dom"
import { consoleDebug } from "src/utils"
import { AuthContext } from "./AuthContext"

// Comma-separated list of trusted parent origins, e.g. "https://pharma.mobilus.com,https://app.mobilus.ca"
const ALLOWED_PARENT_ORIGINS = import.meta.env.VITE_PARENT_ORIGINS
  ? (import.meta.env.VITE_PARENT_ORIGINS as string).split(",").map((o) => o.trim())
  : []

export const ParentAuthProvider = ({
  children,
}: {
  children: React.ReactNode
}) => {
  const [isAuthenticated, setIsAuthenticated] = useState(true) // Assume authenticated via parent
  const [isProcessing, setIsProcessing] = useState(false)
  const [isProcessed, setIsProcessed] = useState(true)
  const navigate = useNavigate()

  useEffect(() => {
    if (
      isAuthenticated &&
      ["/login", "", "/", window.baseName].includes(window.location.pathname)
    ) {
      navigate("/us/profile")
    }
  }, [isAuthenticated, navigate])

  // Listen for auth:expired messages from the parent window
  const handleMessage = useCallback((event: MessageEvent) => {
    // Validate origin if configured
    if (ALLOWED_PARENT_ORIGINS.length > 0 && !ALLOWED_PARENT_ORIGINS.includes(event.origin)) {
      return
    }
    if (event.data?.type === "auth:expired") {
      consoleDebug("Received auth:expired from parent")
      setIsAuthenticated(false)
    }
  }, [])

  useEffect(() => {
    window.addEventListener("message", handleMessage)
    return () => window.removeEventListener("message", handleMessage)
  }, [handleMessage])

  const ctx = {
    isAuthenticated,
    isProcessing,
    isProcessed,
    isReady: isProcessed && !isProcessing,
  }

  consoleDebug("Parent AuthContext", ctx)
  return <AuthContext.Provider value={ctx}>{children}</AuthContext.Provider>
}
